module.exports = __webpack_public_path__ + "img/piste-vue-du-ciel.99b5a1c3.jpg";